import React, { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import SupervisorApi from "../../utility/supervisorApi";

function HeatMapChart() {
  const { fetchOnlyData } = SupervisorApi();
  const [timeRange] = useState(0);
  const [newPeriod, setNewPeriod] = useState("7days");

  const period = [
    { id: 0, key: "7days", time: "One Week" },
    { id: 1, key: "30days", time: "One Month" },
    { id: 2, key: "12months", time: "One Year" },
  ];

  useEffect(() => {
    const selected = period[timeRange];
    if (selected) {
      setNewPeriod(selected.key);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeRange]);

  const chartData = useMutation({
    mutationFn: () =>
      fetchOnlyData(`dashboard/heat-map?date_filter=${newPeriod}`, null, true),
  });

  useEffect(() => {
    chartData.mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newPeriod]);

  useEffect(() => {
    console.log(chartData.data);
  }, [chartData]);

  return (
    <div className="mb-6 w-full overflow-x-auto">
      <div className="flex justify-between items-center">
        <h3 className="text-3xl font-semibold mb-4">Stock Heat Map</h3>
        {/* <HeatmapVisual data={chartData?.data} /> */}
      </div>
    </div>
  );
}

export default HeatMapChart;
